var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SwitchField',{attrs:{"name":"新規登録者のみ","value":_vm.value,"hide-details":""},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }